export const getApiEndpoint = () => {
  // In production, API requests go through the same origin (nginx proxy)
  if (process.env.NODE_ENV === 'production') {
    return ''; // Use relative URLs
  }
  // For development, allow override via environment variable
  return process.env.REACT_APP_API_ENDPOINT || 'http://localhost:4000';
};

export const getHostName = () => {
  return window.APP_CONFIG?.REACT_APP_RIALTO_HOST_NAME || 'default';
};
